"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var UiAction_1 = require("../../uiAction/UiAction");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var CardImage = function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("card-image");
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls.bem) }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "".concat(cls.el("block").pmod("image").bem), style: { backgroundImage: "url(".concat(props.imgSrc, ")") } }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls.el("block").pmod("wrapper").bem) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("block").pmod("content").bem) }, { children: props.content || props.children })), props.actions && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("block").pmod("actions").bem, " mt-4") }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("block").bem, " justify-content-end") }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "float-right" }, { children: props.actions.map(function (e) {
                                    return (0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: e }, e.id);
                                }) })) })) })))] }))] })));
};
exports.CardImage = CardImage;
